import InfoIcon from '@atlaskit/icon/glyph/info';
import { B400 } from '@atlaskit/theme/colors';
import React from 'react';
import { InfoBoxContainer, InfoBoxContent } from './styled';

export type InfoBoxProps = {
  readonly children: React.ReactNode;
  readonly fontSize?: string;
};

export function InfoBox({ children, fontSize }: InfoBoxProps) {
  return (
    <InfoBoxContainer>
      <InfoIcon label="" primaryColor={B400} size="small" />
      <InfoBoxContent fontSize={fontSize}>{children}</InfoBoxContent>
    </InfoBoxContainer>
  );
}
